import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import ContentManager from '../../components/admin/ContentManager';

export default function TendersPage() {
  return (
    <AdminLayout>
      <ContentManager
        title="Tenders Management"
        subtitle="Manage tenders and procurement notices"
        contentType="tenders"
        fields={[
          // Basic Information
          { name: 'title', label: 'Tender Title', type: 'text', required: true },
          { name: 'reference_no', label: 'Tender/Reference Number', type: 'text', placeholder: 'e.g., CISH/TEND/2025/001' },
          { name: 'category', label: 'Category', type: 'select', options: ['Goods', 'Services', 'Works', 'General'] },
          { name: 'estimated_value', label: 'Estimated Value', type: 'text', placeholder: 'e.g., Rs. 15,00,000' },
          { name: 'description', label: 'Tender Description', type: 'richtext', hint: 'Detailed tender description with formatting' },
          
          // Dates
          { name: 'publish_date', label: 'Tender Date / Publish Date', type: 'date' },
          { name: 'last_date', label: 'Last Date to Apply', type: 'date', required: true, hint: 'NEW badge shows until this date' },
          
          // Documents - File Upload
          { name: 'pdf_file', label: 'Tender Document PDF', type: 'file', fileType: 'pdf', hint: 'Upload tender document' },
          { name: 'pdf_url', label: 'Or PDF URL', type: 'text', placeholder: 'External PDF link if not uploading' },
          
          // Links
          { name: 'external_link', label: 'Tender External Link', type: 'text', placeholder: 'GeM or other portal link' },
          
          // Status
          { name: 'show_new', label: 'Show NEW Badge', type: 'checkbox', defaultValue: true, checkboxLabel: 'Display NEW badge (auto-hidden after last date)' },
          { name: 'is_active', label: 'Active', type: 'checkbox', defaultValue: true, checkboxLabel: 'Item is active' },
          { name: 'is_published', label: 'Published', type: 'checkbox', defaultValue: true, checkboxLabel: 'Visible to public' },
        ]}
        columns={['title', 'reference_no', 'category', 'last_date', 'is_published']}
      />
    </AdminLayout>
  );
}
